module.exports = __webpack_public_path__ + "img/features_privacymaster_phone.0e2e52ad.jpg";